import { render, staticRenderFns } from "./WriteEn.vue?vue&type=template&id=9cb87fa4"
import script from "./WriteEn.vue?vue&type=script&lang=js"
export * from "./WriteEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports